import { type Common } from './common.js';
import { type PatientWithAddress } from './models/patient.js';

interface RetrievePatientInformation {
  encounterId?: string;
  ehrInformationId?: string;
}

export class API {
  common: Common;
  baseEndpoint = '/patient-information';

  constructor(common: Common) {
    this.common = common;
  }
  async findPatientInformation(args: RetrievePatientInformation): Promise<PatientWithAddress> {
    const url = this.common.constructPath(this.baseEndpoint, args);
    const { patientInformation, patientAddressMailing, patientAddressPhysical } =
      await this.common.getJSON(url);
    return {
      patientInformation,
      patientAddressMailing,
      patientAddressPhysical,
    };
  }
}
